import axios from 'axios'

export const checkInvitationExists = (email) =>
  axios
    .get(`/authenticated/invitations/exists`, {
      params: {
        email
      }
    })
    .then((res) => res.data)

/**
 * @desc Fetches all Pending User Invitations
 * @desc getValidPendingInvitationsForSupplier in BFF
 * @param {String} supplierId
 */
export const fetchInvitations = (supplierId) =>
  axios
    .get(`/authenticated/invitations?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Add user invitation
 * @desc addInvitation in BFF
 * @param {Object} payload - { invitedBy, invitedEmail, supplierId }
 */
export const addInvitation = (payload) =>
  axios.post('/authenticated/invitations', payload).then((res) => res.data)

/**
 * @desc Re-send user invitation email
 * @desc resendInvitationEmail in BFF
 * @param {String} supplierId
 * @param {String} token - invitation token
 */
export const resendInvitationEmail = (supplierId, token) =>
  axios
    .post(`/authenticated/invitations/email/${token}?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Cancel user invitation
 * @desc cancelInvitation in BFF
 * @param {String} invitationId
 */
export const cancelInvitation = (invitationId) =>
  axios
    .delete(`/authenticated/invitations/${invitationId}`)
    .then((res) => res.data)

/**
 * @desc Accept invitation and set passsword
 * @desc acceptInvitation in BFF
 */
export const acceptInvitation = (supplierId, token, password) =>
  axios
    .post(`/public/invitations/accept/${token}?supplierId=${supplierId}`, {
      password
    })
    .then((res) => res.data)

/**
 * @desc Add agent invitation
 * @param {Object} payload
 */
export const addAgentInvitation = (payload) =>
  axios
    .post('/authenticated/invitations/agent', payload)
    .then((res) => res.data)

export const fetchExpiringAgentInvitationCount = (supplierId, days = 5) =>
  axios
    .get('/authenticated/invitations/agent/expiring-count', {
      params: { supplierId, days }
    })
    .then((res) => res.data)
